import React, {useState} from 'react';
import {InputContainer, NumberInput} from "finform";

const DateInputWrapperForPlaceholder = ({ value, onChange, placeholder, id }) => {
    const [isFocused, setIsFocused] = useState(false);

    const isEmpty = !value;

    const showPlaceholder = !isFocused && isEmpty;

    return (
        <div style={{
            position: 'relative',
        }}>
            <InputContainer
                style={{
                    height: '28px',
                    maxWidth: '100px',
                    minWidth: '100px',
                    margin: '15px 3px'
                }}
            >
                <NumberInput
                    style={{
                        padding: '0 8px',
                        marginTop: '0',
                        height: '28px',
                        lineHeight: '28px'
                    }}
                    id={id}
                    icon={false}
                    value={value}
                    onChange={onChange}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                />
            </InputContainer>
            {/* Кастомный placeholder */}
            {showPlaceholder && (
                <label
                    htmlFor={id}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 10,
                        height: '28px',
                        lineHeight: '28px',
                        color: '#999',
                        pointerEvents: 'none',
                        fontSize: '14px',
                        transition: 'opacity 0.2s ease',
                        userSelect: 'none'
                    }}
                >
                    {placeholder}
                </label>
            )}
        </div>

    );
};

export default DateInputWrapperForPlaceholder;